import styled from 'styled-components';
import MuiChip from '@mui/material/Chip';
import { hexToRgba } from 'src/utils';

interface ChipProps {
  $color: string;
}

export const Chip = styled(MuiChip)<ChipProps>`
  background-color: ${(props) => hexToRgba(props.$color, 0.06)};
  border-radius: 4px;
  text-transform: capitalize;
  border: 1px solid ${(props) => props.theme?.colors.transparent};
  transition:
    border 0.3s ease-out,
    background-color 0.3s ease-out;

  & .MuiChip-label {
    color: ${(props) => props.$color};
    font-size: ${({ size }) => (size === 'small' ? '12px' : '15px')};
    font-weight: ${({ size }) => (size === 'small' ? '600' : '800')};
  }

  &.MuiChip-clickable {
    &:hover {
      border: 1px solid ${(props) => props.$color};
      background-color: ${(props) => hexToRgba(props.$color, 0.06)};
    }
  }
`;
